import {
  IconCameraPlus,
  IconMicrophone01,
  IconRefreshCw04,
  IconScissorsCut01,
  IconSubtitles,
  IconZoomIn,
  Spacing,
} from '@kezios/design-system';
import { Stack, Text } from '@mantine/core';
import { useTranslations } from 'next-intl';

import { Item } from './Item/Item';

const IconsGradient = (
  <linearGradient
    id="paint0_linear_8238_42274"
    x1="3.5"
    y1="3.83331"
    x2="22.6766"
    y2="17.095"
    gradientUnits="userSpaceOnUse"
  >
    <stop stopColor="#EB5B26" />
    <stop offset="1" stopColor="#98242B" />
  </linearGradient>
);

export const HeroDescription = () => {
  const t = useTranslations('section.hero.description');

  return (
    <Stack gap={Spacing.s6}>
      <Text variant="textXl" c="gray.6">
        {t('text')}
      </Text>
      <Stack gap={Spacing.s1}>
        <Item
          Icon={<IconScissorsCut01 size={24} gradient={IconsGradient} />}
          textId="autocutsilences"
        />
        <Item
          Icon={<IconSubtitles size={24} gradient={IconsGradient} />}
          textId="autocaptions"
        />
        <Item
          Icon={<IconMicrophone01 size={24} gradient={IconsGradient} />}
          textId="autocutpodcast"
        />
        <Item
          Icon={<IconZoomIn size={24} gradient={IconsGradient} />}
          textId="autozoom"
        />
        <Item
          Icon={<IconCameraPlus size={24} gradient={IconsGradient} />}
          textId="autobroll"
        />
        <Item
          Icon={<IconRefreshCw04 size={24} gradient={IconsGradient} />}
          textId="autocutrepeat"
        />
      </Stack>
    </Stack>
  );
};
